import { useFetchData, useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import LmsTable from "../ui/LmsTable";
import { IdProps } from "../../interfaces/Global";

const MainTable = () => {
  const actionButtons = ["add", "edit", "remove", "export"];
  return (
    <LmsTable
      actionButtons={actionButtons}
      apiSuffix="menu/loan-sub-status-email-config"
      sortable={["Dispaly", "Description", "Email Template", "Loan Sub Status", "Entering Or Leaving", "Instance", "Updated On"]}
      columnLabelsDictionary={{
        enteringOrLeavingOption: "Entering Or Leaving",
        instanceOption: "Instance"
      }}
    />
  );
};

const emailConfigFormFields = (myForm: BCFormController) => {
  myForm.addCenteredGroup([
    myForm.getDropdownField("Loan Sub Status", "metadata/list-loan-sub-statuses", {
      name: "loanSubStatusId",
      required: true,
    }),
  ]);

  myForm.addCenteredGroup([
      myForm.getLabelField("Entering Or Leaving"),
      myForm.getGroupRadioField("Entering"),
      myForm.getGroupRadioField("Leaving"),
    ], { radioGroupName: "enteringOrLeavingOption", widths: 1 }
);

  myForm.addCenteredGroup([
    myForm.getLabelField("Instance", { width: 2 }),
      myForm.getGroupRadioField("First"),
      myForm.getGroupRadioField("Not First"),
      myForm.getGroupRadioField("Any"),
    ], { radioGroupName: "instanceOption", widths: 1}
  );

  myForm.addCenteredGroup([
      myForm.getLabelField("Has Broker Option", { width: 2 }),
      myForm.getGroupRadioField("Yes"),
      myForm.getGroupRadioField("No"),
      myForm.getGroupRadioField("N/A"),
    ], { radioGroupName: "hasBrokerOption", widths: 1}
  );

  myForm.addCenteredGroup([
      myForm.getLabelField("Origin Option", { width: 2 }),
      myForm.getGroupRadioField("Borrower Portal"),
      myForm.getGroupRadioField("Broker Portal"),
      myForm.getGroupRadioField("Manual Entry"),
      myForm.getGroupRadioField("Any"),
    ], { radioGroupName: "originOption" }
  );

  myForm.addCenteredGroup([
    myForm.getDropdownField("Email Template", "metadata/list-email-templates", {
      name: "emailTemplateId",
      required: true,
    }),
  ]);

  myForm.addCenteredGroup([myForm.getCheckboxField("Is Active", { inline: true })]);
  myForm.addCenteredGroup([myForm.getInputField("Description", { field: "textarea" })]);
  return myForm;
};

const EditNewMenusLoanSubStatusEmailConfigForm = ({ id }: IdProps) => {
  const [{ data = {}, isLoading, error }] = useFetchData(`menu/loan-sub-status-email-config/${id}`);
  const myForm = emailConfigFormFields(new BCFormController(data, { 
    submitSuffix: "menu/loan-sub-status-email-config", 
    submitMethod: "PUT",
    deleteSuffix: "menu/loan-sub-status-email-config",
  }));
  const formActions = ["save", "save-close", "delete", "close"];
  return (
    <LmsFormGenerator
      myForm={myForm}
      isLoading={isLoading}
      error={error}
      actions={formActions}
    />
  );
};

const AddNewMenusLoanSubStatusEmailConfigForm = () => {
  const myForm = new BCFormController({ isActive: true }, { submitSuffix: "menu/loan-sub-status-email-config", submitMethod: "POST", blankWidth: 5 });
  emailConfigFormFields(myForm);
  const formActions = ["save-new", "save-continue", "save-close", "close"];
  return <LmsFormGenerator myForm={myForm} actions={formActions} />;
};

const LmsNewMenusLoanSubStatusEmailConfig = ({ params = {}, history }) => {
  const { isMainPage, isAdd, isEdit, isActionAllowed, id } =
    useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return (
    <>
      {isMainPage && <MainTable />}
      {isAdd && <AddNewMenusLoanSubStatusEmailConfigForm />}
      {isEdit && <EditNewMenusLoanSubStatusEmailConfigForm id={id} />}
    </>
  );
};

export default LmsNewMenusLoanSubStatusEmailConfig;
